import { Link } from "react-router-dom";
import { RoutePaths } from "../../models";
import { TabIndex } from "./types";

export function LoanIdLink({
  path,
  tab,
  id,
}: {
  path: RoutePaths;
  tab: TabIndex;
  id: string;
}) {
  let navigationLink = "";
  if (tab === "COMMERCIAL_OD") navigationLink = `${path}/commercial/${id}`;
  else if (tab === "WORKING_CAPITAL_TERM_LOAN")
    navigationLink = `${path}/wctl-loan/${id}`;
  return (
    <Link to={navigationLink} className="table-link">
      {id}
    </Link>
  );
}
